import axiosClient from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import axiosClientDistribution from "axiosClient/indexDistribution";
import axiosClientHyperDrive from "axiosClient/indexHyperdrive";
import axiosClientStilo from "axiosClient/indexStilo";

export async function userLoginAPI(cred) {
  return await axiosClient.post(`/api/v1/admin/login`, cred);  //axiosClientStilo upate
}

export async function hyperWolfUserLoginAPI(cred) {
  return await axiosHyperwolfClient.post(`/api/v1/admin/login`, cred);
}


export async function userSignupAPI(cred) {
  return await axiosClient.post(`/api/v1/admin/create`, cred);
}

export async function forgotPasswordAPI(cred) {
  return await axiosClient.post(`/api/v1/admin/forgot`, cred);
}


export async function resetPasswordAPI(data) {
  return await axiosClient.post(`/api/v1/admin/reset`, data);
}

export async function resetPinAPI(data) {
  return await axiosClientDistribution.post(`/api/v1/admin/driver-kit-verification/user/reset/pin`, data);
}

export async function resetHyerdrivePasswordAPI(data) {
  return await axiosClientHyperDrive.post(`/api/v1/fleet/reset/password`, data);
}


export async function getUserInfoAPI(userId = '') {
  return await axiosClient.get(`/api/v1/admin/${userId}`);   //axiosClientStilo upate
}

export async function userLogoutAPI(data) {
  return await axiosClient.post('api/v1/admin/store/logout', data)
}